import http from '@/utils/http';

const PROXY = '/proxy';

const API = {

  // 查询症状分类列表
  getSymptomList (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/symptom/list', data, option);
  },
  // 查询症状分类列表
  getSymptomdetail (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/symptom/detail', data, option);
  },
  // 拼音查找
  pinyinSearch (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/symptom/pinyinSearch', data, option);
  },
  // 人形症状查询
  queryPersonFace (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/personFace/list', data, option);
  },
  // 查询科室列表
  queryDeptPageList (data = {}, option = {}) {
    return http.post(PROXY + '/api/third/admin/orm/queryPage', data, option);
  },
  // 查找医院介绍
  getHospitalInfo (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/hospitalInfo/hospitalIntro', data, option);
  },
  // 文章列表
  getHospitalInfoList (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/hospitalInfo/list', data, option);
  },
  // 查看文章详情
  getHospitalInfoDetail (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/hospitalInfo/detail', data, option);
  },

  // 专家科室列表
  getexpertDeptList (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/expertDept/list', data, option);
  },

  // 专家医生分页列表
  getExpertDoctorQueryPage (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/expertDoctor/queryPage', data, option);
  },
  // 专家医生详情
  getExpertDoctorDetail (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/expertDoctor/detail', data, option);
  },
  // 屏保设置详情
  getScreenProtectDetail (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/screenProtect/detail', data, option);
  },
  // 获取初始化平台时间和模拟导航速率
  getSettingDetail (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/setting/detail', data, option);
  },
  // 获取大屏二维码映射id
  getQcodeMapParamId (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust//qrcodemap/getQcodeMapParamId', data, option);
  }

};

export default API;
